import fakeTracksResponse from "../assets/data/tracksResponse.json";
import fakeSingleTrackResponse from "../assets/data/singleTrackResponse.json";
import fakeSearchResultsResponse from "../assets/data/searchResults.json";
import fakeMiscSearchResultsResponse from "../assets/data/miscSearchResults.json";
import fakeTracksFromCollectionResponse from "../assets/data/tracksFromAlbum.json";
import { getIdFromUri, getParamString } from "../utils/utils";
import { useMockSpotify } from "../config/vars";
import { sendRequestWithCredentials } from "./spotifyCredentials.api.js";

const SEARCH_PAGE_SIZE = 20;
const MISC_SEARCH_LIMIT = 8;
const paginationTokens = {};

export const getNextPage = async (token) => {
  console.log("spotifyApi::getNextPage");
  console.log("token");
  console.log(token);
  console.log("paginationTokens[token]");
  console.log(paginationTokens[token]);
  console.log("paginationTokens");
  console.log(paginationTokens);
  return sendSearchRequest(paginationTokens[token]);
};

/**
 * @param  {Object} param0
 * @param  {string} param0.query
 * @param  {number} param0.offest
 */
const addPaginationToken = ({ query, offset }) => {
  const hash = `${query}${offset}`;
  paginationTokens[hash] = { query, offset: offset + SEARCH_PAGE_SIZE };
  return hash;
};

/**
 *
 * @param {Object} param0
 * @param {string} param0.query
 * @param {number} param0.offset
 */
export const sendSearchRequest = async ({ query, offset, country }) => {
  let errorMessage;
  console.log(`Start send search API request with query: ${query}`);
  try {
    if (!query) {
      throw new Error("No query string");
    }
    if (!offset) {
      offset = 0;
    }

    if (useMockSpotify) {
      return {
        ok: true,
        data: getSearchResultsData(fakeSearchResultsResponse, query, offset),
      };
    }

    const paramsMap = {
      query,
      limit: SEARCH_PAGE_SIZE,
      type: "track",
      offset,
    };
    if (country) {
      paramsMap.market = country;
    }
    const paramsString = getParamString(paramsMap);
    const path = `/search${paramsString}`;
    const { ok, data } = await sendRequestWithCredentials({ path });

    if (!ok) {
      throw new Error(
        `Could not get search results from Spotify with query: ${query}`,
      );
    }
    return {
      ok: true,
      data: getSearchResultsData(data, query, offset),
    };
  } catch (error) {
    errorMessage = error.message;
    console.warn(errorMessage);
    return {
      ok: false,
      error,
    };
  }
};

export const getSearchResultsData = ({ tracks }, query, offset) => {
  const isMoreResults = tracks.total - SEARCH_PAGE_SIZE > offset;
  return {
    ...tracks,
    items: tracks.items.map((track) => ({ ...track, offset })),
    nextPageToken: isMoreResults ? addPaginationToken({ query, offset }) : null,
  };
};

const getFakeResponse = (data, error) => {
  if (error) {
    return {
      ok: false,
      error,
    };
  } else {
    return {
      ok: true,
      data,
    };
  }
};

export const sendGetTracksRequest = async (trackUris) => {
  const trackIds = trackUris.map(getIdFromUri);
  if (!trackIds || trackIds.length < 1) {
    return { ok: false, error: { message: "No tracks to fetch" } };
  }
  if (useMockSpotify) {
    return getFakeResponse(fakeTracksResponse);
  }

  const params = {
    ids: trackIds,
  };
  const paramString = getParamString(params);
  const path = `/tracks${paramString}`;

  return sendRequestWithCredentials({ path });
};

export const getTrackById = async (id) => {
  console.log("getTrackById");
  if (useMockSpotify) {
    return getFakeResponse(fakeSingleTrackResponse);
  }

  const path = `/tracks/${id}`;

  return sendRequestWithCredentials({ path });
};
/**
 * Gets tracks for album, playlist, or artist.
 *
 * @param  {Object} param0
 * @param  {string} param0.type
 * @param  {string} param0.id
 * @param  {string} param0.country
 */
export const getTracksForCollection = async ({ type, id, country = "US" }) => {
  if (useMockSpotify) {
    return getFakeResponse(fakeTracksFromCollectionResponse);
  }
  let paramString = "";
  switch (type) {
    case "artist":
      paramString = getParamString({ country });
      const { data: artistResponse } = await sendRequestWithCredentials({
        path: `/artists/${id}/top-tracks${paramString}`,
      });
      return { ok: true, data: normalizeArtistResponse(artistResponse) };
    case "album":
      paramString = getParamString({
        market: country,
        limit: SEARCH_PAGE_SIZE,
      });
      return sendRequestWithCredentials({
        path: `/albums/${id}/tracks${paramString}`,
      });
    case "playlist":
      paramString = getParamString({
        market: country,
        limit: SEARCH_PAGE_SIZE,
      });
      const { data: playlistResponse } = await sendRequestWithCredentials({
        path: `/playlists/${id}/tracks${paramString}`,
      });
      return { ok: true, data: normalizePlaylistResponse(playlistResponse) };
    default:
      return { ok: false, error: { message: "Need type" } };
  }
};

const normalizePlaylistResponse = (data) => {
  return {
    items: data.items.map(({ track }) => track),
  };
};
const normalizeArtistResponse = (data) => {
  data.items = data.tracks;
  return data;
};

/**
 *
 * @param {Object} param0
 * @param {string} param0.query
 * @param {string} param0.country
 */
export const sendSearchForMiscRequest = async ({ query, country }) => {
  if (!query) {
    return { ok: false, error: "Need query" };
  }
  if (useMockSpotify) {
    return getFakeResponse(fakeMiscSearchResultsResponse);
  }
  const paramsMap = {
    type: "artist,album,playlist",
    q: query,
    limit: MISC_SEARCH_LIMIT,
  };
  if (country) {
    paramsMap.market = country;
  }
  const paramString = getParamString(paramsMap);
  const path = `/search${paramString}`;
  return sendRequestWithCredentials({ path });
};
